//NOTE синхронизировано с api/src/types/user.ts
export enum UserRole {
    Administrator,
    User,
}

export interface IUser {
    login: string;
    user_id: number;
    node_id: number;
    type: UserRole;
}

export interface DbUser extends IUser {
    description: string | null;
    email: string | null;
}

export interface ChangePassUser extends IUser {
    oldpassword: string;
    password: string;
}

export interface CreateUser {
    login: string;
    password: string;
    node_id: number;
    type: UserRole;
    email: string | null;
    description: string | null;
}

export function isAdmin(user: IUser): boolean {
    return user.type === UserRole.Administrator;
}

export function isRoot(user: IUser): boolean {
    return isAdmin(user) && user.login === 'root' && user.user_id === 1 && user.node_id === 1;
}
